import React from 'react';
import { useTranslation } from 'react-i18next';
import Divider from '@atoms/Divider/Divider';
import Section from '@atoms/Section/Section';
import Text from '@atoms/Text/Text';
import Title from '@atoms/Title/Title';
import NavFooterSecondary from '../Nav/NavFooterSecondary';
import './_Footer.scss';

FooterAddress.defaultProps = {
    theme: 'dark', // light
    variant: 'Simple', // extended, minimal
};

function FooterAddress(props) {
    const { t } = useTranslation();

    const mod_class = [
        'Footer',
        props.theme !== undefined ? 'theme-' + props.theme : '',
    ].join(' ');

    return (
        <div className={mod_class}>
            <Section container="large" spacingBottom="xs">
                <div className="g_1_1 g_clearfix">
                    <Divider invisible spacing="m" />
                    <Text align="left" size="xs" theme="white">
                        {t('footer.emergency.situation.text')}{' '}
                        <a
                            href="https://www.ch.ch/de/notfallnummern-erste-hilfe/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t('footer.emergency.situation.support.link.label')}
                        </a>
                    </Text>
                </div>
            </Section>

            <Section container="large">
                <Divider theme="white" />
            </Section>

            <Section container="large" spacing="xs">
                <div className="Footer--Copy">
                    <NavFooterSecondary />
                    <div>
                        <Title tag="span" size="xs" theme="white">
                            © {new Date().getFullYear()} Aepsy AG
                        </Title>
                    </div>
                </div>
            </Section>
        </div>
    );
}

export default FooterAddress;
